<template>
    <header class="bg-white shadow-md">
        <Toast />
        <!-- 🔹 Main Header Section -->
        <div class="mx-auto flex items-center justify-between p-2">
            
            <!-- Logo -->
            <div class="font-bold text-gray-800 mx-10 w-40 flex flex-row justify-center items-center" v-if="customerMobile === undefined || customerMobile === null">
                <Link :href="route('index')"><img :src="'/storage/uploads/application_logo/' + appSettings?.business_logo" class="py-5 min-w-full"/></Link>
            </div>

            <div class="font-bold text-gray-800 w-28 md:w-40 lg:w-40 sm:w-40 mx-10 flex flex-row justify-center items-center" v-else>
                <Link :href="route('index')"><img :src="'/storage/uploads/application_logo/' + appSettings?.business_logo" class="py-5 min-w-full"/></Link>
            </div>

            <!-- 🔹 Search Bar -->
            <div class="hidden lg:flex flex-grow mx-[9.5rem] lg:mx-[4.5rem] md:mx-[4.5rem] sm:mx-[4.5rem] -space-x-10">
               
                <input 
                    type="text" 
                    placeholder="Search for products..." 
                    v-model="searchTerm"
                    @keydown.enter="searchProduct"
                    class="w-full px-4 py-2 border mx-auto rounded-none focus:outline-none focus:ring focus:ring-blue-300"
                >
                <button class="bg-green-600 text-white px-4 py-3 hover:bg-green-700" @click.once="searchProduct">
                    <i class="pi pi-search"></i>
                </button>
            </div>

            <!-- 🔹 Icons (Cart, Wishlist, Profile, Login) -->
            <div class="flex items-center space-x-20 mx-5">
                
                <Link :href="route('product.wish-list')" class="relative text-gray-600 hover:text-blue-500">
                    <i class="pi pi-heart text-xl" style="font-size: 1.5rem"></i> <span class="absolute -top-0 -right-5 bg-red-500 w-7 text-center h-7 text-white text-sm rounded-full items-center flex justify-center px-1">{{ wishListTotalQty }}</span>
                    
                </Link>
                <a href="#" class="relative text-gray-600 hover:text-blue-500" @click.prevent="openCartItem">
                    <i class="pi pi-shopping-cart text-xl" style="font-size: 1.5rem"></i>  <span class="absolute -top-0 -right-5 bg-red-500 w-7 text-center h-7 text-white text-sm rounded-full items-center flex justify-center">{{ cartTotalQty }}</span>
                </a>
                
                <Link :href="route('customer-login.form')" class="text-gray-600 hover:text-blue-500 flex flex-col gap-2 items-center" v-if="customerMobile === undefined || customerMobile === null"><i class="pi pi-user text-xl" style="font-size: 1.2rem"></i> Login</Link>
                <!-- <Link :href="route('customer-login.logout')" class="text-gray-600 hover:text-blue-500 flex flex-col gap-2 items-center" v-else><i class="pi pi-user text-xl" style="font-size: 1.2rem"></i> Logout</Link> -->
                <div 
                    class="relative inline-block"
                    @mouseenter="showSubMenu" 
                    v-else
                >
                    <!-- Trigger -->
                    <span class="cursor-pointer flex flex-row gap-2 items-center"><i class="pi pi-user text-xl" style="font-size: 1.2rem"></i> <i class="pi pi-chevron-down"></i></span>

                    <!-- Dropdown -->
                    <Transition
                    enter-active-class="transition ease-out duration-200"
                    enter-from-class="opacity-0 scale-95 translate-y-2"
                    enter-to-class="opacity-100 scale-100 translate-y-0"
                    leave-active-class="transition ease-in duration-150"
                    leave-from-class="opacity-100 scale-100 translate-y-0"
                    leave-to-class="opacity-0 scale-95 translate-y-2"
                    >
                        <div 
                        v-if="isShowSubMenu" 
                        @mouseleave="hideSubMenu"
                        class="absolute top-10 right-0 bg-white shadow-md rounded-md w-48 p-2 z-50"
                        >
                        <div class="flex flex-col gap-2">
                            <Link 
                            :href="route('order.my-panel')" 
                            class="text-gray-600 hover:text-blue-500 flex flex-row gap-3 items-center"
                            >
                            <i class="pi pi-user text-xl"></i> 
                            <span>My Panel</span>
                            </Link>
                            <Link 
                            :href="route('customer-login.logout')" 
                            class="text-gray-600 hover:text-blue-500 flex flex-row gap-3 items-center"
                            >
                            <i class="pi pi-sign-out text-xl"></i> 
                            <span>Logout</span>
                            </Link>
                        </div>
                        </div>
                    </Transition>
                </div>
                
            </div>

            <!-- 🔹 Mobile Menu Button -->
            <!-- <button id="mobile-menu-button" class="lg:hidden text-gray-600 hover:text-blue-500 text-2xl">
            ☰
            </button> -->
        </div>

        <!-- 🔹 Navigation Menu -->
        <!-- <nav class="bg-green-600 hidden lg:flex px-10 space-x-6 py-5">
            <Link :href="route('index')" class="text-white hover:text-gray-200 text-xl font-extrabold">Home</Link>
            <a href="#" class="text-white hover:text-gray-200 text-xl font-extrabold">Shop</a>
            <div class="relative group">
            <a href="#" class="text-white hover:text-gray-200 text-xl font-extrabold flex items-center">Categories ⌄</a>
            <div class="absolute hidden group-hover:block bg-white shadow-md mt-2 rounded-lg w-48 z-10">
                <a href="#" class="block px-4 py-2 hover:bg-gray-200">Men's Clothing</a>
                <a href="#" class="block px-4 py-2 hover:bg-gray-200">Women's Fashion</a>
                <a href="#" class="block px-4 py-2 hover:bg-gray-200">Electronics</a>
                <a href="#" class="block px-4 py-2 hover:bg-gray-200">Home & Kitchen</a>
            </div>
            </div>
            <a href="#" class="text-white hover:text-gray-200 text-xl font-extrabold">Deals</a>
            <a href="#" class="text-white hover:text-gray-200 text-xl font-extrabold">Contact</a>
        </nav> -->

        <!-- 🔹 Mobile Search Bar (Hidden on Desktop) -->
        <!-- <div class="lg:hidden px-4 py-2">
            <input 
            type="text" 
            placeholder="Search for products..." 
            class="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
            >
        </div> -->

        <!-- 🔹 Mobile Navigation Menu (Initially Hidden) -->
        <!-- <div id="mobile-menu" class="hidden lg:hidden bg-white shadow-md">
            <a href="#" class="block px-4 py-3 border-b hover:bg-gray-100">Home</a>
            <a href="#" class="block px-4 py-3 border-b hover:bg-gray-100">Shop</a>
            <a href="#" class="block px-4 py-3 border-b hover:bg-gray-100">Categories</a>
            <a href="#" class="block px-4 py-3 border-b hover:bg-gray-100">Deals</a>
            <a href="#" class="block px-4 py-3 hover:bg-gray-100">Contact</a>
        </div> -->

    </header>
</template>

<script setup lang="ts">
import { useSearchComposable } from '@/Composables/SearchComposable/SearchComposable';
import ApplicationSettingModel from '@/Interfaces/ApplicationSettings/ApplicationSettingModel';
import ProductModel from '@/Interfaces/Product/ProductModel';
import { useShoppingCartStore } from '@/Stores/ShoppingCart/ShoppingCartStore';
import { Link, router, usePage } from '@inertiajs/vue3';
import { storeToRefs } from 'pinia';
import { useToast } from 'primevue/usetoast';
import { computed, onMounted, ref } from 'vue';

const {appSettings} = defineProps<{
    'appSettings': ApplicationSettingModel
}>();

const toast = useToast();

const shoppingStore = useShoppingCartStore();
const { localStorageCartItems, localStorageWishListItems, visibleRight, searchProductList, searchTerm } = storeToRefs(shoppingStore);

const cartTotalQty = computed(() => localStorageCartItems.value?.reduce((sum, item) => sum + Number(item?.cart_qty), 0));
const wishListTotalQty = computed(() => localStorageWishListItems.value?.reduce((sum, item) => sum + Number(item?.cart_qty), 0));

const openCartItem = () => {
    visibleRight.value = true;
}

const isShowSubMenu = ref(false)

const showSubMenu = () => {
  isShowSubMenu.value = true
}
const hideSubMenu = () => {
  isShowSubMenu.value = false
}

const customerMobile = usePage().props.flash?.customerMobile;
const customerName = usePage().props.flash?.customer_information?.customer_name;

const { searchProduct } = useSearchComposable(searchTerm);

onMounted(() => {
    document.getElementById('mobile-menu-button')?.addEventListener('click', function() {
        document.getElementById('mobile-menu')?.classList.toggle('hidden');
    });
})
</script>

<style scoped>
:deep(.p-menuitem-text) {
  color: white !important;
}

:deep(.p-menuitem-link) {
  color: #333 !important;
}

:deep(.p-menuitem-content) {
  background-color: transparent !important; /* Ensures no background */
}

:deep(.p-menuitem-content:hover) {
  background-color: transparent !important; /* Removes hover background */
}

/* Remove hover background for main menu items */
:deep(.p-menuitem:hover) {
  background-color: transparent !important;
}

/* Remove hover background for submenu items */
:deep(.p-submenu-list .p-menuitem:hover) {
  background-color: transparent !important;
}

/* Make sure submenu background stays correct */
:deep(.p-submenu-list) {
  background-color: #1f2937 !important; /* Tailwind's gray-900 */
}

.p-menubar.p-menubar-mobile .p-menubar-root-list {
    background: #1f2937 !important;
}
</style>